import axios from 'axios';
import {
  OvulatoryEventComparisonQuery,
  OvulatoryEventComparisonRow,
  OvulatoryEventDayRangeQuery,
  OvulatoryEventPrediction,
  OvulatoryEventScorecardCounts,
} from '../../common/model/dto/ovulatory-event-prediction/ovulatory-event-prediction';
import { Paginated } from '../../common/types';
import { ADMIN_OVULATORY_EVENT_PREDICTION_ROUTE } from '../../api/backend';

// The backend answers 200 with an empty body, not null or [], when a member has
// no prediction, and axios hands that over as an empty string.
const isObject = (data: unknown): data is object =>
  typeof data === 'object' && data !== null;

export const getLatestOvulatoryEventPrediction = async (
  userId: string
): Promise<OvulatoryEventPrediction | null> => {
  const { data } = await axios.get<OvulatoryEventPrediction | ''>(
    `${ADMIN_OVULATORY_EVENT_PREDICTION_ROUTE}/users/${userId}`
  );

  return isObject(data) ? data : null;
};

export const getOvulatoryEventPredictions = async (
  userId: string,
  params: OvulatoryEventDayRangeQuery
): Promise<OvulatoryEventPrediction[]> => {
  const { data } = await axios.get<OvulatoryEventPrediction[] | ''>(
    `${ADMIN_OVULATORY_EVENT_PREDICTION_ROUTE}/users/${userId}/predictions`,
    { params }
  );

  return Array.isArray(data) ? data : [];
};

export const getOvulatoryEventComparison = async (
  userId: string,
  params: OvulatoryEventComparisonQuery
): Promise<Paginated<OvulatoryEventComparisonRow>> => {
  const { data } = await axios.get<Paginated<OvulatoryEventComparisonRow> | ''>(
    `${ADMIN_OVULATORY_EVENT_PREDICTION_ROUTE}/users/${userId}/comparison`,
    { params }
  );

  return isObject(data) && Array.isArray(data.docs)
    ? data
    : { total: 0, limit: params.limit, offset: params.offset, docs: [] };
};

export const getOvulatoryEventScorecard = async (
  userId: string,
  params: OvulatoryEventDayRangeQuery
): Promise<OvulatoryEventScorecardCounts> => {
  const { data } = await axios.get<OvulatoryEventScorecardCounts>(
    `${ADMIN_OVULATORY_EVENT_PREDICTION_ROUTE}/users/${userId}/scorecard`,
    { params }
  );

  return data;
};
